import { BM, } from './backend';
import { ENV } from './global_options';
import { performanceMeasureEnd, performanceMeasureStart } from './dev_tools';
import { MutationObserverTarget } from './mutation_observer';
import { TEXT_NODE_SYMBOL, isTextNode } from './type_symbol';
export class TextNode {
    /* @internal */
    constructor(text, owner) {
        var _a;
        /** @internal */
        this._$slotElement = null;
        /** @internal */
        this._$destroyOnRemoval = 0 /* AutoDestroyState.Disabled */;
        /** @internal */
        this._$subtreeSlotStart = null;
        /** @internal */
        this._$subtreeSlotEnd = null;
        /** @internal */
        this._$mutationObserverTarget = null;
        this._$text = String(text);
        let backendElement = null;
        const context = owner.getBackendContext();
        if (context) {
            if (ENV.DEV)
                performanceMeasureStart('backend.createTextNode');
            if (BM.DOMLIKE || (BM.DYNAMIC && owner.getBackendMode() === 3 /* BackendMode.Domlike */)) {
                backendElement = context.document.createTextNode(text);
            }
            else if (BM.SHADOW || (BM.DYNAMIC && owner.getBackendMode() === 1 /* BackendMode.Shadow */)) {
                const backend = owner._$backendShadowRoot;
                backendElement = (_a = backend === null || backend === void 0 ? void 0 : backend.createTextNode(text)) !== null && _a !== void 0 ? _a : null;
            }
            else {
                const backend = context;
                backendElement = backend.createTextNode(text);
            }
        }
        if (ENV.DEV)
            performanceMeasureEnd();
        this._$backendElement = backendElement;
        this.ownerShadowRoot = owner;
        this.parentNode = null;
        this.parentIndex = -1;
        this.containingSlot = undefined;
    }
    /* @internal */
    static create(text, ownerShadowRoot) {
        return new TextNode(text, ownerShadowRoot);
    }
    asTextNode() {
        return this;
    }
    // eslint-disable-next-line class-methods-use-this
    asElement() {
        return null;
    }
    // eslint-disable-next-line class-methods-use-this
    asNativeNode() {
        return null;
    }
    // eslint-disable-next-line class-methods-use-this
    asVirtualNode() {
        return null;
    }
    // eslint-disable-next-line class-methods-use-this
    asShadowRoot() {
        return null;
    }
    // eslint-disable-next-line class-methods-use-this
    asGeneralComponent() {
        return null;
    }
    // eslint-disable-next-line class-methods-use-this
    asInstanceOf() {
        return null;
    }
    /** Destroy the backend element */
    destroyBackendElement() {
        if (this._$backendElement) {
            if (!(BM.DOMLIKE ||
                (BM.DYNAMIC && this.ownerShadowRoot.getBackendMode() === 3 /* BackendMode.Domlike */))) {
                if (ENV.DEV)
                    performanceMeasureStart('backend.release');
                this._$backendElement.release();
                if (ENV.DEV)
                    performanceMeasureEnd();
            }
        }
        if (this.ownerShadowRoot._$nodeTreeContext.dropBackendAfterRelease) {
            this._$backendElement = null;
        }
    }
    /**
     * Destroy the backend element when removed from any parent element
     */
    destroyBackendElementOnRemoval() {
        this._$destroyOnRemoval = 1 /* AutoDestroyState.Enabled */;
    }
    /**
     * Cancel the destroy scheduling of the backend element
     */
    cancelDestroyBackendElementOnRemoval() {
        this._$destroyOnRemoval = 0 /* AutoDestroyState.Disabled */;
    }
    /**
     * Destroy the backend element when removed from any parent element
     *
     * @deprecated Use `destroyBackendElementOnRemoval` instead.
     */
    destroyBackendElementOnDetach() {
        this._$destroyOnRemoval = 1 /* AutoDestroyState.Enabled */;
    }
    /**
     * Cancel the destroy scheduling of the backend element
     *
     * @deprecated Use `cancelDestroyBackendElementOnRemoval` instead.
     */
    cancelDestroyBackendElementOnDetach() {
        this._$destroyOnRemoval = 0 /* AutoDestroyState.Disabled */;
    }
    /** Get the backend element */
    getBackendElement() {
        return this._$backendElement;
    }
    /** Get the backend context */
    getBackendContext() {
        return this.ownerShadowRoot.getBackendContext();
    }
    /** Get composed parent (including virtual nodes) */
    getComposedParent() {
        if (this.containingSlot !== undefined)
            return this.containingSlot;
        let parent = this.parentNode;
        while (parent === null || parent === void 0 ? void 0 : parent._$inheritSlots) {
            parent = parent.parentNode;
        }
        return parent;
    }
    get $$() {
        return this._$backendElement;
    }
    get textContent() {
        return this._$text;
    }
    set textContent(text) {
        const newText = String(text);
        if (newText === this._$text)
            return;
        this._$text = newText;
        if (this._$backendElement) {
            if (ENV.DEV)
                performanceMeasureStart('backend.setText');
            if (BM.DOMLIKE ||
                (BM.DYNAMIC && this.ownerShadowRoot.getBackendMode() === 3 /* BackendMode.Domlike */)) {
                ;
                this._$backendElement.textContent = this._$text;
            }
            else {
                ;
                this._$backendElement.setText(this._$text);
            }
            if (ENV.DEV)
                performanceMeasureEnd();
        }
        if (this._$mutationObserverTarget) {
            MutationObserverTarget.callTextObservers(this, {
                type: 'characterData',
                target: this,
            });
        }
    }
}
TextNode.isTextNode = isTextNode;
TextNode.prototype[TEXT_NODE_SYMBOL] = true;
//# sourceMappingURL=text_node.js.map